let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jpLot")).then(() => parcelRequire('8LJrf'));